import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = { class: "data-item" };
const _hoisted_2 = { class: "data-item__header" };
const _hoisted_3 = { class: "data-item__title" };
const _hoisted_4 = { class: "data-item__actions" };
const _hoisted_5 = { class: "data-item__content" };
const _hoisted_6 = {
    key: 0,
    class: "data-item__section"
};
import { onMounted, ref, watch } from 'vue';
import exportProfileRepository from "../services/ShopExportProfileRepository";
import env from '../services/AppEnv';
import trans from '@astina/paloma-common-ui/src/services/Translator';
import AppForm from "@astina/paloma-common-ui/src/components/form/AppForm.vue";
import { saveShopExportProfile } from "../commands/SaveShopExportProfile";
import { useRouter } from "vue-router";
export default /*@__PURE__*/ _defineComponent({
    __name: 'ExportProfileCreateView',
    setup(__props) {
        const router = useRouter();
        const draft = ref(createDraft());
        const form = ref(null);
        const sources = ref([]);
        const converters = ref([]);
        const transports = ref([]);
        const validation = ref({ errors: [], fields: {} });
        const loading = ref(false);
        onMounted(() => loadSources()
            .then(loadConverters)
            .then(loadTransports)
            .then(initForm));
        function onSubmit() {
            loading.value = true;
            saveShopExportProfile(draft.value)
                .then(profile => {
                router.push({ name: 'integration_export_edit', params: { id: profile.id } });
            })
                .catch((v) => {
                validation.value = v;
            })
                .finally(() => loading.value = false);
        }
        function onCancel() {
            router.push({ name: 'integration_export' });
        }
        watch(() => draft.value.source, onDraftReaderChange);
        function onDraftReaderChange() {
            const draftLocal = draft.value;
            if (!draftLocal.name) {
                const source = sources.value.find(s => s.name === draftLocal.source);
                draftLocal.name = (source && source.label) || '';
            }
            initForm();
        }
        function initForm() {
            form.value = createFormConfig();
        }
        function loadSources() {
            return exportProfileRepository.listSources()
                .then(s => sources.value = s);
        }
        function loadConverters() {
            return exportProfileRepository.listConverters()
                .then(c => converters.value = c);
        }
        function loadTransports() {
            return exportProfileRepository.listTransports()
                .then(t => transports.value = t);
        }
        function createFormConfig() {
            return {
                name: 'export_profile',
                fields: [
                    {
                        name: 'source',
                        label: trans('export_profile.source'),
                        type: 'choice',
                        options: {
                            required: true,
                            choices: sources.value.map(source => {
                                return { value: source.name, label: source.label };
                            }),
                        },
                    },
                    {
                        name: 'name',
                        label: trans('export_profile.name'),
                        type: 'text',
                        options: {
                            required: true,
                            maxLength: 255,
                        }
                    },
                    {
                        name: 'format',
                        label: trans('export_profile.format'),
                        type: 'choice',
                        options: {
                            required: true,
                            choices: converters.value.map(converter => {
                                return { value: converter.name, label: converter.label };
                            }),
                        },
                    },
                    {
                        name: 'transport',
                        label: trans('export_profile.transfer'),
                        type: 'choice',
                        options: {
                            required: true,
                            choices: transports.value.map(transport => {
                                return { value: transport.name, label: transport.label };
                            }),
                        },
                    },
                ],
            };
        }
        function createDraft() {
            return {
                id: null,
                locale: env.locale,
                name: "",
                status: 'inactive',
                schedule: "0 0 0 * * ?",
                scheduleZoneId: "UTC",
                source: "",
                sourceSettings: {},
                format: "",
                formatSettings: {},
                transport: "",
                transportSettings: {}
            };
        }
        return (_ctx, _cache) => {
            const _component_router_link = _resolveComponent("router-link");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("header", _hoisted_2, [
                    _createElementVNode("h1", _hoisted_3, _toDisplayString(_ctx.$t('export_profile.new')), 1),
                    _cache[0] || (_cache[0] = _createTextVNode()),
                    _createElementVNode("div", _hoisted_4, [
                        _createVNode(_component_router_link, {
                            to: { name: 'integration_export' },
                            class: "button button--outline"
                        }, {
                            default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.$t('cancel')), 1)
                            ]),
                            _: 1
                        })
                    ])
                ]),
                _cache[1] || (_cache[1] = _createTextVNode()),
                _createElementVNode("div", _hoisted_5, [
                    (form.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                            _createVNode(AppForm, {
                                form: form.value,
                                data: draft.value,
                                validation: validation.value,
                                loading: loading.value,
                                onSubmit: onSubmit,
                                "submit-icon": "save",
                                onCancel: onCancel
                            }, null, 8, ["form", "data", "validation", "loading"])
                        ]))
                        : _createCommentVNode("", true)
                ])
            ]));
        };
    }
});
